/* LB Update 291 (Auftrag F07): Breakpoint der Ankuendigungsleiste zwischen JavaScript und CSS vereinheitlicht.

   Ursache: theme.js (theme.config.mediaQuerySmall) sieht bis einschliesslich 769 px "Handy" (max-width: 769px) und baut den
   Flickity-Slider, das Theme-CSS der Leiste schaltet dagegen ab 769 px auf Desktop (min-width: 769px, bei compact=false
   display:flex). Bei genau 769 px gelten beide gleichzeitig: Slider im Flex-Container ergibt vier 10-px-Folien, unsichtbaren
   Text und eine 137,57 px hohe Leiste.

   Vertrag nach dieser Datei (gilt NUR fuer #AnnouncementSlider, theme.js wird nicht veraendert):
     Slider  <=>  Breite <= 768 px  ODER  data-compact="true"      (CSS: Handy max-width:768px, Desktop min-width:769px)
   Der Abgleich laeuft nach dem Theme-Code und stellt den Zustand her, den der Vertrag verlangt: beim ersten Laden, beim
   Wechsel 768/769 (dort feuert theme.js gar nichts), nach den Theme-Ereignissen matchSmall/unmatchSmall (feuern bei 769/770)
   und nach Neuaufbau der Section im Theme-Editor. Idempotent (zweites Laden der Datei tut nichts), mit Cleanup
   (window.lbAnnouncementFix.cleanup()).

   Nicht Teil dieser Korrektur: weitere Stellen in theme.js, die theme.config.bpSmall lesen (z. B. Sticky-Verhalten der
   Leiste bei sticky_on_mobile=false und der Kopfzeile bei exakt 769 px).

   LB Update 291 (Auftrag N-leiste, VV-R01, Runde 2): Layoutsprung bei 769 px - belegte Ursache. theme.js baut den Slider sofort, wenn es ausgefuehrt wird
   (Dokument 'interactive', Handy-Grenze 769 px); diese Datei ist ein spaeteres defer-Skript und laeuft erst nach den davor stehenden Skripten
   (lb-size-sheet.js, lb-fix-dialoge.js; im Netz liegen oft Hunderte Millisekunden dazwischen). In dieser Zeit malt der Browser die Leiste mit dem
   kaputten Slider (Folien nebeneinander in einem Flex-Container, Leiste +84 bis +124 px hoeher); beim Abbau springt die Seite zurueck: zwei Spruenge
   mit je ca. 0,09-0,13 CLS (Kopfzeile und Hauptinhalt y 67 -> 191 -> 66). Den Zustand zwischen Aufbau und Abbau kann diese Datei nicht verhindern
   (sie laeuft zu spaet). Deshalb sorgt jetzt CSS in sections/announcement.liquid (steht vor dem ersten Bild im Dokument) dafuer, dass die Leiste ab
   769 px mit Slider genauso aussieht wie ohne - dort gibt es dann nichts mehr zu springen. Der MutationObserver unten (Slider gegen den Vertrag
   sofort wieder abbauen) bleibt als zweite Sicherung und raeumt den Zustand auf. Die frueher hier beschriebene reservierte "Ausland"-Zeile gibt es
   nicht mehr: die Lieferzeit ist eine eigene einzeilige Folie (snippets/announcement-bar.liquid). */
(function () {
  'use strict';
  if (window.lbAnnouncementFix) return;

  var HANDY_MAX = 768; /* CSS: @media (max-width:768px) = Handy, @media (min-width:769px) = Desktop */
  var mq = window.matchMedia ? window.matchMedia('screen and (max-width: ' + HANDY_MAX + 'px)') : null;
  var eigene = null; /* von dieser Datei erzeugte theme.Slideshow-Instanz */
  var verzoegerung = null;
  var zaehler = { abgebaut: 0, aufgebaut: 0, beobachtet: 0 };
  var beobachter = null; /* MutationObserver auf die Klasse von #AnnouncementSlider */
  var beobachtetEl = null;
  var fokusPlayer = null, fokusTimer = null;

  function manuellPausiert(el) {
    var wrapper = el && (el.closest('.slideshow-wrapper') || el);
    return !!(wrapper && wrapper.querySelector('.slideshow__pause.is-paused'));
  }
  function fokusPause() {
    var el = leiste();
    if (!el || !el.contains(document.activeElement)) return;
    var f = window.Flickity && window.Flickity.data(el);
    if (f && f.player && f.player.state === 'playing') {
      fokusPlayer = f;
      f.pausePlayer();
    }
  }
  function fokusWeiter() {
    clearTimeout(fokusTimer);
    fokusTimer = setTimeout(function () {
      var el = leiste(), f = fokusPlayer;
      if (el && el.contains(document.activeElement)) return;
      fokusPlayer = null;
      if (f && f.isActive && f.player && f.player.state === 'paused' && !manuellPausiert(el)) f.unpausePlayer();
    }, 0);
  }
  function beiFokus(e) { var el = leiste(); if (el && el.contains(e.target)) fokusPause(); }
  document.addEventListener('focusin', beiFokus);
  document.addEventListener('focusout', fokusWeiter);

  function leiste() { return document.getElementById('AnnouncementSlider'); }
  function sliderSoll(el) { return !!(mq && mq.matches) || el.getAttribute('data-compact') === 'true'; }
  function sliderIst(el) { return el.classList.contains('flickity-enabled'); }

  function abbauen(el) {
    var f = window.Flickity && typeof window.Flickity.data === 'function' ? window.Flickity.data(el) : null;
    /* Hat theme.js beim Aufraeumen einer aelteren Instanz die Kennung des Elements geloescht, bleibt die eigene Referenz. */
    if (!f && eigene && eigene.slideshow && eigene.slideshow.isActive) f = eigene.slideshow;
    if (f && typeof f.destroy === 'function') { f.destroy(); zaehler.abgebaut++; }
    eigene = null;
  }

  function aufbauen(el) {
    if (!window.theme || typeof window.theme.Slideshow !== 'function') return;
    /* gleiche Argumente wie theme.announcementBar (theme.js) */
    eigene = new window.theme.Slideshow(el, {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: window.theme.config && window.theme.config.rtl ? 'right' : 'left'
    });
    zaehler.aufgebaut++;
  }

  function abgleichen() {
    var el = leiste();
    if (!el || !window.Flickity) return;
    var soll = sliderSoll(el);
    var ist = sliderIst(el);
    if (soll && !ist) aufbauen(el);
    else if (!soll && ist) abbauen(el);
    fokusPause();
  }

  /* Sicherung gegen Endlos-Streit mit theme.js: nach 50 Korrekturen (Ab-/Aufbau) durch den Beobachter gibt er auf (die Ereignis-Abgleiche bleiben). */
  function beiKlassenwechsel() {
    var vorher = zaehler.abgebaut + zaehler.aufgebaut;
    abgleichen();
    if (zaehler.abgebaut + zaehler.aufgebaut !== vorher) zaehler.beobachtet++;
    if (zaehler.beobachtet > 50) { if (beobachter) beobachter.disconnect(); beobachter = null; }
  }

  function beobachten() {
    var el = leiste();
    if (!el || typeof MutationObserver !== 'function') return;
    if (beobachter && beobachtetEl === el) return;
    if (beobachter) beobachter.disconnect();
    beobachtetEl = el;
    beobachter = new MutationObserver(beiKlassenwechsel);
    beobachter.observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  function spaeter() {
    beobachten();
    abgleichen();
    clearTimeout(verzoegerung);
    verzoegerung = setTimeout(abgleichen, 60);
  }

  var resizeTimer = null;
  function beiResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(abgleichen, 120);
  }

  if (mq) {
    if (mq.addEventListener) mq.addEventListener('change', abgleichen);
    else if (mq.addListener) mq.addListener(abgleichen);
  }
  document.addEventListener('matchSmall', abgleichen);
  document.addEventListener('unmatchSmall', abgleichen);
  document.addEventListener('shopify:section:load', spaeter);
  window.addEventListener('load', abgleichen);
  window.addEventListener('pageshow', abgleichen);
  window.addEventListener('resize', beiResize);

  window.lbAnnouncementFix = {
    version: '291-F07-3',
    abgleichen: abgleichen,
    beobachten: beobachten,
    zaehler: zaehler,
    cleanup: function () {
      if (mq) {
        if (mq.removeEventListener) mq.removeEventListener('change', abgleichen);
        else if (mq.removeListener) mq.removeListener(abgleichen);
      }
      document.removeEventListener('matchSmall', abgleichen);
      document.removeEventListener('unmatchSmall', abgleichen);
      document.removeEventListener('shopify:section:load', spaeter);
      window.removeEventListener('load', abgleichen);
      window.removeEventListener('pageshow', abgleichen);
      window.removeEventListener('resize', beiResize);
      clearTimeout(verzoegerung);
      clearTimeout(resizeTimer);
      clearTimeout(fokusTimer);
      document.removeEventListener('focusin', beiFokus);
      document.removeEventListener('focusout', fokusWeiter);
      if (fokusPlayer && fokusPlayer.isActive && fokusPlayer.player && fokusPlayer.player.state === 'paused' && !manuellPausiert(leiste())) fokusPlayer.unpausePlayer();
      fokusPlayer = null;
      if (beobachter) beobachter.disconnect();
      beobachter = null;
      delete window.lbAnnouncementFix;
    }
  };

  beobachten();
  abgleichen();
})();
